import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ArticleProvider } from './contexts/ArticleContext';
import { UserProvider } from './contexts/UserContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Archive from './pages/Archive';
import WriteArticle from './pages/WriteArticle';
import Profile from './pages/Profile';
import ArticleDetail from './pages/ArticleDetail';
// 在路由配置中添加编辑文章的路由



function App() {
  return (
    <UserProvider>
      <ArticleProvider>
        <Router>
          <div className="App">
            <Navbar />
            <div className="container">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/archive" element={<Archive />} />
                <Route path="/write" element={<WriteArticle />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/article/:id" element={<ArticleDetail />} />
                <Route path="/write/:id" element={<WriteArticle />} />  
              </Routes>
            </div>
          </div>
        </Router>
      </ArticleProvider>
    </UserProvider>
  );
}

export default App;